import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import {
    selectAll,
    padSlides,
} from "../simplerToolkit.js";

window.addEventListener("load", () => {
    const carousels = selectAll("section.our-partners .swiper");
    if (!carousels?.length) return;

    const sharedBreakpoints = {
        640: {slidesPerView: 2},
        720: {slidesPerView: 3},
        840: {slidesPerView: 4},
    };

    const edgeRightBreakpoints = {
        ...sharedBreakpoints,
        1024: {slidesPerView: 4.5},
        1200: {slidesPerView: 5.75},
    };

    const fullWidthBreakpoints = {
        ...sharedBreakpoints,
        1100: {slidesPerView: 5.75},
        1400: {slidesPerView: 6.5},
    };

    carousels.forEach((el) => {
        padSlides(el, 12);

        new Swiper(el, {
            slidesPerView: 2,
            spaceBetween: 10,
            loop: true,
            autoplay: {delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: false},
            speed: 1000,
            roundLengths: true,
            breakpoints: el.classList.contains('full-width') ? fullWidthBreakpoints : edgeRightBreakpoints,
        });
    });
});
